export const TIME_FORMATS = [
  { value: 12, label: '1:00 am' },
  { value: 24, label: '13:00' },
];
